import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { Variables } from 'graphql-request';

import {
  GraphQLAccessTokenClientEhrm,
  GraphQLUnauthenticatedClient,
} from '@hcs/http-clients';
import { CERBERUS_PROXY_ENABLED, CERBERUS_URL } from '@hcs/urls';
import { PULL_REQUEST_ID } from '@hcs/webapps';

export const CerberusClient = CERBERUS_PROXY_ENABLED
  ? GraphQLAccessTokenClientEhrm(CERBERUS_URL, {
      headers: {
        'X-Build': `hcs-nx${PULL_REQUEST_ID ? '-pr' : ''}/${
          import.meta.env.NX_BUILD
        }`,
      },
    })
  : GraphQLUnauthenticatedClient(CERBERUS_URL, {});

export const CerberusApi = {
  fetchQuery: async <Response, V extends Variables>(
    query: TypedDocumentNode<Response, V>,
    variables: V,
    signal?: AbortSignal,
  ) => {
    // eslint-disable-next-line
    // @ts-ignore This is is an issue with the library type definitions
    return await CerberusClient.request<Response, V>({
      document: query,
      variables,
      signal,
    });
  },
  bulkFetchQuery: async <
    Response,
    T extends Array<{ response: Response; variables: Variables }>,
  >(queryAndVarsArray: {
    [K in keyof T]: {
      document: TypedDocumentNode<T[K]['response'], T[K]['variables']>;
      variables: T[K]['variables'];
    };
  }) => {
    return await CerberusClient.batchRequests(queryAndVarsArray);
  },
};
